<ng-select
  (blur)="onBlur()"
  (focus)="onFocus()"
  [formControl]="_proxyControl"
  [editableSearchTerm]="false"
  [items]="_countries$ | async"
  [loading]="(_countries$ | async) === null"
  [loadingText]="loadingText"
  [openOnEnter]="false"
  [placeholder]="placeholder"
  [readonly]="_isDisabled$ | async"
  [virtualScroll]="true"
  [trackByFn]="_trackBy"
  [labelForId]="labelForId"
  bindLabel="localized"
  bindValue="codeA3"
>
  <ng-template ng-option-tmp let-item="item">
    <i [class]="'flag-icon flag-icon--' + item.codeA2.toLowerCase()"></i>
    {{ item.localized }}
  </ng-template>
  <ng-template ng-notfound-tmp>
    <p class="not-found">{{ notFoundText }}</p>
  </ng-template>
</ng-select>
